import React from 'react';
import styles from './BusinessCard.module.css';
import { Star, Phone, MessageCircle, Eye, Zap, Award, Globe, MapPin } from 'lucide-react';
import StarRating from '../components/StarRating/startRating';

const BusinessCard = ({ business, isSelected, onCardClick }) => {
    const {
        businessName,
        description,
        overallRating,
        businessProfileOverview,
        isHighlighted,
        isSponsored,
        streetNumber,
        streetName,
        suburb,
        phone,
    } = business;

    const profilePic = businessProfileOverview?.profile_Pic;

    return (
        <div
            className={`${styles.businessCard} ${isSelected ? styles.selected : ''} ${isHighlighted ? styles.highlighted : ''}`}
            onClick={() => onCardClick(business.businessId)}
        >
            {isSponsored && <div className={styles.sponsoredBanner}><Zap size={16} /> Sponsored</div>}
            <div className={styles.cardContent}>
                <div className={styles.leftColumn}>
                    {profilePic ? (
                        <img src={profilePic} alt={businessName} className={styles.profilePic} />
                    ) : (
                        <div className={styles.avatarFallback}>{businessName ? businessName.charAt(0) : ''}</div>
                    )}
                </div>
                <div className={styles.middleColumn}>
                    <h3 className={styles.businessName}>{businessName}</h3>
                    <div className={styles.ratingContainer}>
                        <StarRating ratings={overallRating} />
                        <span className={styles.ratingText}>{overallRating ? overallRating.toFixed(1) : 'No rating'}</span>
                    </div>
                    <p className={styles.description}>{description}</p>
                    <div className={styles.addressSection}>
                        <MapPin size={16} />
                        <span>{streetNumber} {streetName}, {suburb}</span>
                    </div>
                    <div className={styles.phoneSection}>
                        <Phone size={16} />
                        <span>{phone}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BusinessCard;
